<template>
	<div class="w-full flex flex-col gap-4 items-center p-5">
		<section class="white-rounded-box w-1/2 mx-auto p-7">
			<h2>Ping from notification</h2>
			<Post
				class="mt-2"
				:post="ping"
				:includeComments="false"
				:isLast="false"
				:isConnectionRequest="
					ping.mentions[0]
						? ping.mentions[0].pivot.ping_type != 0
						: false
				"
				:user="{}"
			/>
			<p
				class="mt-3 text-center"
				v-if="
					ping.mentions[0]
						? ping.mentions[0].pivot.ping_type == 0
						: false
				"
			>
				Please <a href="/register"><strong>register</strong></a> or
				<a href="/login"><strong>login</strong></a> to reply to this
				ping
			</p>
			<p class="mt-3 text-center" v-else>
				Please <a href="/register"><strong>register</strong></a> or
				<a href="/login"><strong>login</strong></a> to accept this connection request
			</p>
		</section>
	</div>
</template>

<script>
import Post from "../Utils/Post.vue";

export default {
	props: ["ping"],
	components: { Post },
};
</script>
